<template lang="pug">

  .app-modal(v-if='localShowing' @click.self='hide()')
    .dialog
      .header
        slot(name='header')
      .body
        slot(name='body')
      .footer
        slot(name='footer')

  
</template>

<script>
export default {
  name: 'app-modal',
  props: ['showing'],
  data: function(){
    return {
      localShowing: this.showing,
      isUpdatingFromProp: false
    };
  },
  watch:{
    localShowing: function(newV){
      // Solo emitir si no estamos actualizando desde el prop
      if (!this.isUpdatingFromProp) {
        this.$emit('showing', newV);
      }
      // Bloquear/desbloquear scroll del body para evitar parpadeo
      if (newV) {
        document.body.classList.add('modal-open');
        document.body.style.overflow = 'hidden';
        document.body.style.paddingRight = '0px';
      } else {
        document.body.classList.remove('modal-open');
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
      }
    },
    showing: function(newV){
      // Marcar que estamos actualizando desde el prop para evitar ciclo
      this.isUpdatingFromProp = true;
      this.localShowing = newV;
      this.$nextTick(() => {
        this.isUpdatingFromProp = false;
      });
    }
  },
  methods:{
    show:function(){this.localShowing = true;},
    hide:function(){this.localShowing = false;}
  },
  beforeDestroy() {
    // Asegurar que el scroll se restaure si el componente se destruye
    document.body.classList.remove('modal-open');
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  }
}
</script>
